// Dynamic subscription selector block: toggle one-time/subscribe, swap each option's per-unit
// text from variant metafield data, and keep the embedded product form (variant id + selling
// plan) in sync with the checked option. Submitting the form goes through the theme's
// `product-form` component, which adds to the cart via AJAX and opens the cart drawer.
if (!window.customElements.get('subscription-selector-dynamic')) {
  window.customElements.define(
    'subscription-selector-dynamic',
    class SubscriptionSelectorDynamic extends window.HTMLElement {
      connectedCallback() {
        this.oneTimeBtn = this.querySelector('[data-toggle="one-time"]');
        this.subscribeBtn = this.querySelector('[data-toggle="subscribe"]');
        this.options = [...this.querySelectorAll('[data-option]')];
        this.radios = [...this.querySelectorAll('input[type="radio"]')];
        this.freqValue = this.querySelector('[data-frequency-value]');
        this.cta = this.querySelector('[data-cta]');
        this.ctaTotal = this.querySelector('[data-cta-total]');
        this.ctaCompare = this.querySelector('[data-cta-compare]');
        this.variantInput = this.querySelector('input[name="id"]');
        this.sellingPlanInput = this.querySelector('input[name="selling_plan"]');
        this.isOneTime = this.classList.contains('is-one-time');

        this.oneTimeBtn?.addEventListener('click', () => this.setMode(true));
        this.subscribeBtn?.addEventListener('click', () => this.setMode(false));
        this.radios.forEach((radio) => radio.addEventListener('change', () => this.render()));
        this.addEventListener('variant:add', this.closeQuickBuyOnAdd);

        this.render();
      }

      setMode(isOneTime) {
        this.isOneTime = isOneTime;
        this.oneTimeBtn?.classList.toggle('is-active', isOneTime);
        this.subscribeBtn?.classList.toggle('is-active', !isOneTime);
        this.classList.toggle('is-one-time', isOneTime);
        this.render();
      }

      render() {
        const p = this.isOneTime ? 'one' : 'sub';

        this.options.forEach((option) => {
          const data = option.querySelector('input[type="radio"]').dataset;
          this.setText(option.querySelector('[data-per]'), data[`${p}Per`]);
          this.setText(option.querySelector('[data-compare]'), data[`${p}Compare`]);
          this.setText(option.querySelector('[data-savings]'), data[`${p}Savings`]);
        });

        const checked = this.radios.find((radio) => radio.checked) || this.radios[0];
        if (!checked) return;
        const data = checked.dataset;

        if (this.freqValue) this.freqValue.textContent = data.frequency || '';
        this.setText(this.ctaTotal, data[`${p}Total`]);
        this.setText(this.ctaCompare, data[`${p}CompareTotal`]);

        if (this.variantInput) this.variantInput.value = checked.value;
        if (this.sellingPlanInput) {
          const planId = data.sellingPlanId || '';
          this.sellingPlanInput.value = planId;
          this.sellingPlanInput.disabled = this.isOneTime || planId === '';
        }
        if (this.cta) this.cta.disabled = data.available === 'false';
      }

      setText(el, value) {
        if (!el) return;
        el.textContent = value || '';
        el.classList.toggle('is-hidden', !value);
      }

      closeQuickBuyOnAdd(event) {
        const drawer = this.closest('quick-buy-drawer');
        if (!drawer) return;

        event.stopPropagation();
        event.detail.blockCartDrawerOpening = true;
        drawer.hide();
      }
    },
  );
}
